import React from "react";
import "./CardOverlay.scss";
import CardComponent from "./CardComponent";

class OverlayCardComponent extends CardComponent {
      // Methode zur Erzeugung des Beschreibungstextes
  getModalDescriptionContent = () => {
    const { values, description, loading } = this.props.card;
    return values ? 
        this.getAbilitys(values)
      : 
      <textarea
        id="description"
        className="description"
        disabled={!description || loading}
        name="description"
        placeholder="Keine Beschreibung verfügbar."
        defaultValue={description}
        onChange={this.props.handleDescriptionChange}
        />
    ;


  };
}

const CardOverlay = ({ card, onClose, handleDelete, handleImageUpload, handleAnalyzeImage, handleGenerateCard }) => {
  if (!card) return null;

  const handleDescriptionChange = (e) => {
    card.tempDescription = e.target.value;
  }

  const overlayButtons = [
        <button key="delete-button" className="delete-button" onClick={handleDelete}>
            🗑️
        </button>,

        !card.file && 
        <button key="file-button" className="image-upload">            
            <input
                type="file"
                id="image-upload"
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleImageUpload}
            />
            <label htmlFor="image-upload" className="file-button-label">Bild hinzufügen</label>
        </button>,

        card.file && !card.description && (
            <button
            key="analyse-button"
            onClick={handleAnalyzeImage}
            disabled={card.loading}
            className="action-button"
            >
            {card.loading ? "Analysiert..." : "Analyse starten"}
            </button>
        ),

        card.description && !card.values && (
            <button
              key="generieren-button"
              onClick={handleGenerateCard}
              disabled={card.loading}
              className="action-button"
            >
              {card.loading ? "Generiert..." : "Karte generieren"}
            </button>
          ),

          card.values && (
            <button
              key="regenerieren-button"
              onClick={handleGenerateCard}
              disabled={card.loading}
              className="action-button"
            >
              {card.loading ? "Generiert..." : "Karte neu generieren"}
            </button>
          )
    ]

  return (
    <div className="overlay-container">
      {/* Button-Leiste */}
      <div className="overlay-header">
        <div className="overlay-buttons">
            {overlayButtons}
        </div>
        <div className="basic-buttons">
            <button className="close-button" onClick={onClose}>
            ✖
            </button>
        </div>
      </div>

      {/* Kartenbereich */}
      <div className="overlay-body">
        <OverlayCardComponent 
            key={card.id}
            card={card} 
            handleDescriptionChange={handleDescriptionChange}
        />
      </div>
    </div>
  );
};

export default CardOverlay;
